export default function Footer({ children }: { children: React.ReactNode }) {
  return (
    <div
      className={`drawer-footer absolute bottom-0 h-[71px] left-0 right-0 z-20 bg-[#F7F7F7] border-t border-gray-300 p-4 flex items-center justify-between`}
    >
      {children}
    </div>
  );
}
